let templateSettings = {
    matcher: /{{\D+?}}/g,
    from: /{{\s*/i,
    to: /\s*}}/i
};

const template = (str, params, settings = {}) => {
    settings = {
        ...templateSettings,
        ...settings
    };

    return str.replace(settings.matcher, function(match) {
        let key = match.replace(settings.from, '').replace(settings.to, '');
        let value = params[key] || ' ';

        return value;
    });
};

export default template;
